import { Component, Input, OnInit } from '@angular/core';
import { IDataUserLogged } from 'src/app/model/http/users.model';
import { Router } from '@angular/router';
import { NotificationsService } from '../../services/notifications.service';
import { DataService } from '../../services/data.service';
import { SecurityService } from '../../services/security.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() dataUser: IDataUserLogged = {
    userName: '',
    userId: 0,
    shortName: '',
    lettersName: '',
    userEmail: '',
    fullName: '',
    rols: []
  };

  isDialogOpen = false;

  thereAreNewNotifications = false;
  userId: number = 0;
  countNotifications: string = ""

  menuClose: boolean = false;

  constructor(
    private readonly securityService: SecurityService,
    private readonly router: Router,
    private readonly notificationService: NotificationsService,
    public readonly dataService: DataService
  ) { }


  ngOnInit(): void {
    this.initListeners();
    this.dataService.getDataUser().subscribe(data => {
      this.userId = data.userId;
      this.getCountNotifications();
    })
  }

  initListeners() {
    this.dataService.getNotificationSse().subscribe(() => this.getCountNotifications())
  }

  logout() {
    this.menuClose = true;
    this.securityService.logout();
  }

  goPerfil() {
    this.menuClose = true;
    this.router.navigate(['/perfil']);
  }

  getCountNotifications() {
    this.notificationService.getCountNotifications(`${this.userId}`).subscribe((count) => {
      this.thereAreNewNotifications = count > 0;
      this.countNotifications = `${count}`;
    })
  }


  closePanel(isDialogOpen: boolean) {



    this.isDialogOpen = !isDialogOpen;

    this.dataService.setBlocklScreen({
      show: this.isDialogOpen,
      data: null
    });

  }

  onHandle() {

    if (!this.isDialogOpen) {
      return;
    }

    this.isDialogOpen = false;

    this.dataService.setBlocklScreen({
      show: this.isDialogOpen,
      data: null
    });

  }

}
